import React, { useState } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "./ui/dialog";
import { Loader2, KeyRound } from "lucide-react";
import api from "../api";
import { useToast } from "../hooks/use-toast";

const ChangePasswordDialog = ({ open, onOpenChange }) => {
  const { toast } = useToast();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next.length < 8) { setError("New password must be at least 8 characters."); return; }
    if (next !== confirm) { setError("New passwords do not match."); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast({ title: "Password updated", description: "Your password was changed successfully." });
      setCurrent(""); setNext(""); setConfirm("");
      onOpenChange(false);
    } catch (err) {
      setError(err?.response?.data?.detail || "Could not change password.");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0f0a17] border-white/10 text-white sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-ui font-extrabold uppercase flex items-center gap-2">
            <KeyRound size={18} style={{ color: "#8cff00" }} /> Change password
          </DialogTitle>
          <DialogDescription className="text-white/50">Update the password for your account.</DialogDescription>
        </DialogHeader>
        {error && <div className="rounded-xl border border-red-400/40 bg-red-500/10 px-4 py-2.5 text-sm text-red-300">{error}</div>}
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="font-ui font-semibold text-white text-sm block mb-2">Current password</label>
            <input type="password" required value={current} onChange={(e) => setCurrent(e.target.value)} className="hss-input" placeholder="Current password" />
          </div>
          <div>
            <label className="font-ui font-semibold text-white text-sm block mb-2">New password</label>
            <input type="password" required value={next} onChange={(e) => setNext(e.target.value)} className="hss-input" placeholder="At least 8 characters" />
          </div>
          <div>
            <label className="font-ui font-semibold text-white text-sm block mb-2">Confirm new password</label>
            <input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="hss-input" placeholder="Re-enter new password" />
          </div>
          <DialogFooter>
            <button type="submit" disabled={busy} className="btn-green w-full justify-center">
              {busy ? <Loader2 size={16} className="animate-spin" /> : <KeyRound size={16} />} Update password
            </button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ChangePasswordDialog;
